var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleplusIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8593_1254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.239 49.478C42.0735 49.478 52.478 39.0735 52.478 26.239C52.478 13.4045 42.0735 3 29.239 3C16.4045 3 6 13.4045 6 26.239C6 39.0735 16.4045 49.478 29.239 49.478Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2874 33.389C23.3426 33.3991 21.471 32.6475 20.0734 31.295C19.3908 30.6415 18.8476 29.8566 18.4765 28.9876C18.1054 28.1186 17.9141 27.1834 17.9141 26.2385C17.9141 25.2935 18.1054 24.3583 18.4765 23.4893C18.8476 22.6203 19.3908 21.8354 20.0734 21.182C21.436 19.877 23.2384 19.1304 25.1246 19.0896C27.0109 19.0489 28.8438 19.717 30.2614 20.962L28.0894 23.026C27.2994 22.3796 26.3102 22.0263 25.2894 22.026C24.1552 22.0097 23.0609 22.4442 22.2467 23.2341C21.4326 24.024 20.9653 25.1048 20.9474 26.239C20.9664 27.3721 21.4339 28.4515 22.2474 29.2405C23.061 30.0295 24.1542 30.4637 25.2874 30.448C26.1575 30.4517 27.0087 30.1952 27.7319 29.7114C28.455 29.2276 29.0169 28.5386 29.3454 27.733H25.1944V24.746H32.4944C32.75 25.9176 32.7004 27.1353 32.3501 28.2823C31.9999 29.4292 31.3609 30.4669 30.4944 31.296C29.0984 32.6464 27.2297 33.3975 25.2874 33.389ZM38.5874 29.27H36.7204V26.782H34.1544V24.972H36.7204V22.483H38.5874V24.972H41.1534V26.782H38.5874V29.271V29.27Z",
    fill: "#5044E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8593_1254",
    x: 0,
    y: 0,
    width: 58.4766,
    height: 58.478,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8593_1254"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8593_1254",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplusIcon);
export default __webpack_public_path__ + "static/media/googleplus_icon.ba9b895ae9c9455f033f6221b520f9a5.svg";
export { ForwardRef as ReactComponent };